module.exports = __webpack_public_path__ + "img/1568431820.9fd248d6.jpg";